import e from "react";
import { A as o } from "./jwt-decode.esm-kZY1eG1f.js";
const n = () => {
  const t = e.useContext(o);
  if (!t)
    throw new Error("useAuth must be used within an <AuthProvider/>");
  return t;
};
export {
  n as u
};
